export default {
  methods: {
    addEventListeners(listeners = []) {
      listeners.forEach(([target, event, listener, options]) => {
        try {
          if (target) {
            target.addEventListener(event, listener, options);
          }
        } catch (e) {
          console.error('Error adding event listener!', e);
        }
      });

      this.$once('hook:beforeDestroy', () => {
        listeners.forEach(([target, event, listener, options]) => {
          try {
            if (target) {
              target.removeEventListener(event, listener, options);
            }
          } catch (e) {
            console.error('Error removing event listener!', e);
          }
        });
      });
    },
  },
};
